var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "69F694A5-8774-4A85-B245-E25556B21352")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Permatrol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pagina_principal",
    transform: "translate(-291.000000, -170.000000)",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRIMERA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(291.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13686838e-13,0.5 L15.4764723,0.5",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,6.5 L15.4764723,6.5",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,12.5 L15.4764723,12.5",
    id: "Path-3"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.f1b76707.svg";
export { ForwardRef as ReactComponent };